var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, TextField } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
var useStyles = makeStyles(function () { return ({
    input: function (_a) {
        var center = _a.center;
        return ({
            textAlign: center ? 'center' : 'initial'
        });
    },
    helperText: {
        fontSize: 'inherit',
        textAlign: 'center'
    }
}); });
export var UITextField = function (_a) {
    var _b, _c;
    var center = _a.center, rest = __rest(_a, ["center"]);
    var classes = useStyles({ center: center });
    return (React.createElement(TextField, __assign({ variant: 'filled', margin: "dense", hiddenLabel: true }, rest, { inputProps: __assign(__assign({}, rest.inputProps), { className: clsx(classes.input, (_b = rest.inputProps) === null || _b === void 0 ? void 0 : _b.className) }), FormHelperTextProps: __assign(__assign({}, rest.FormHelperTextProps), { className: clsx(classes.helperText, (_c = rest.FormHelperTextProps) === null || _c === void 0 ? void 0 : _c.className) }) })));
};
